import { useService } from 'react-reservice';

import { ICompanyExposure } from '@aqx-core/common/api/dealer/model';

import dealerService, { IDealerContext } from './service';
import { TCompanyExposureLiveFields, TDealerExposurePositionRowType } from './types';

export const useDealerLoading = () => useService(dealerService, (context: IDealerContext) => context.loading);

export const useDealerSelectedTab = () => useService(dealerService, (context: IDealerContext) => context.selectedTab);

export const useDealerCompanyExposure = () =>
  useService(dealerService, (context: IDealerContext) => context.companyExposureSearchResult);

export const useDealerCompanyExposureCount = () =>
  useService(dealerService, (context: IDealerContext) => context.companyExposureSearchResult.length ?? 0);

export const useDealerTypeFilter = () =>
  useService(dealerService, (context: IDealerContext) => ({
    showTypeFilter: context.showTypeFilter,
    checkedTypes: context.checkedTypes
  }));

export const useDealerSearch = () => useService(dealerService, (context: IDealerContext) => context.search);

export const useDealerLiveExposure = <K extends keyof Pick<ICompanyExposure, TCompanyExposureLiveFields>>(
  symbol: string,
  rowType: TDealerExposurePositionRowType,
  key: K
): ICompanyExposure[K] | null => {
  return useService(dealerService, (context: IDealerContext) => {
    const symbolData = context.allSymbolMap.get(symbol);

    if (!symbolData) {
      return null;
    }

    return symbolData[rowType]?.[key] || null;
  });
};
